export default __webpack_public_path__ + "static/media/Computer troubleshooting-pana 1.f494c681.png";